import { render, staticRenderFns } from "./normas-collapse.vue?vue&type=template&id=e962389e&scoped=true"
import script from "./normas-collapse.vue?vue&type=script&lang=js"
export * from "./normas-collapse.vue?vue&type=script&lang=js"
import style0 from "./normas-collapse.vue?vue&type=style&index=0&id=e962389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e962389e",
  null
  
)

export default component.exports